import React, { useState } from 'react';
import Form65Navigator from './sections/Form65Navigator';
import BankruptSection from './sections/BankruptSection';
import CreditorSection from './sections/CreditorSection';

// ========== NMA-BANKRUPTCY PLATFORM v3.0 ==========
// Three-section architecture: Bankrupt · Trustee · Creditor
// © 2026 Dr. Olutoyese Oyelese

function PlatformLanding({ onNavigate }) {
  return (
    <div style={{ minHeight: '100vh', background: '#F7F5F0', fontFamily: "'DM Sans', -apple-system, sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Source+Serif+4:ital,opsz,wght@0,8..60,300;0,8..60,400;0,8..60,600;0,8..60,700;1,8..60,400&family=DM+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap" rel="stylesheet" />
      
      <header style={{ background: '#1A1A1A', color: 'white', padding: '48px 24px 44px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, letterSpacing: 1.5, textTransform: 'uppercase', opacity: 0.85, marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>navigationalmind.com / nma-bankruptcy</span>
            <a
              href="https://navigationalmind.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: 11, textTransform: 'none', letterSpacing: '0.03em' }}
              onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.85)'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}
            >
              navigationalmind.com ↗
            </a>
          </div>
          <h1 style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 36, fontWeight: 700, marginBottom: 8, letterSpacing: -0.5 }}>
            NMA Bankruptcy
          </h1>
          <p style={{ fontSize: 15, opacity: 0.7, maxWidth: 560, lineHeight: 1.5 }}>
            Tools for the Canadian bankruptcy process. Plain language. No legalese. Grounded in the BIA and OSB directives.
          </p>
        </div>
      </header>

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          
          {/* Bankrupt Section */}
          <div 
            onClick={() => onNavigate('bankrupt')}
            style={{ 
              background: '#2B5A3D', color: 'white', borderRadius: 12, padding: '32px 28px', 
              cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; }}
          >
            <div style={{ fontSize: 28, marginBottom: 12 }}>👤</div>
            <h2 style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
              I'm Bankrupt
            </h2>
            <p style={{ fontSize: 14, opacity: 0.85, lineHeight: 1.5, marginBottom: 16 }}>
              Timeline navigator, surplus income calculator, duties checklist, your rights, debts that survive, provincial exemptions.
            </p>
            <div style={{ fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
              6 tools →
            </div>
          </div>

          {/* Trustee Section */}
          <div 
            onClick={() => onNavigate('trustee')}
            style={{ 
              background: 'white', color: '#1A1A1A', borderRadius: 12, padding: '32px 28px', 
              cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
              border: '1px solid #E5E0D8',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)'; }}
          >
            <div style={{ fontSize: 28, marginBottom: 12 }}>⚖️</div>
            <h2 style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
              I'm a Trustee
            </h2>
            <p style={{ fontSize: 14, color: '#5C5C5C', lineHeight: 1.5, marginBottom: 16 }}>
              Form 65 Navigator with epistemic probe questions, consistency gate, surplus income calculation, and export tools.
            </p>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#2B5A3D', display: 'flex', alignItems: 'center', gap: 6 }}>
              Form 65 Navigator v2.1 →
            </div>
          </div>

          {/* Creditor Section */}
          <div 
            onClick={() => onNavigate('creditor')}
            style={{ 
              background: '#1a5276', color: 'white', borderRadius: 12, padding: '32px 28px', 
              cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; }}
          >
            <div style={{ fontSize: 28, marginBottom: 12 }}>🏦</div>
            <h2 style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
              I'm a Creditor
            </h2>
            <p style={{ fontSize: 14, opacity: 0.85, lineHeight: 1.5, marginBottom: 16 }}>
              Proof of claim guide, dividend estimator, meeting of creditors, creditor rights, opposition to discharge, and priority of claims.
            </p>
            <div style={{ fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
              5 tools →
            </div>
          </div>
        </div>

        <div style={{ marginTop: 48, background: '#1A1A1A', borderRadius: 12, padding: '32px 28px', textAlign: 'center' }}>
          <div style={{ fontSize: 22, marginBottom: 12 }}>🔒</div>
          <h3 style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 20, fontWeight: 700, color: 'white', margin: '0 0 12px' }}>
            Your Privacy Is Absolute
          </h3>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, maxWidth: 600, margin: '0 auto 16px' }}>
            We do not track you. We do not collect your data. We do not use cookies. We do not store anything you enter. Every calculation runs entirely in your browser and disappears when you close the page.
          </p>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, maxWidth: 520, margin: '0 auto' }}>
            No accounts. No sign-ups. No analytics. No third-party scripts. Nothing leaves your device. Built by a physician — not an ad company.
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: 60, fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: '#8A8A8A' }}>
          NMA Bankruptcy v4.0 · © 2026 Dr. Olutoyese Oyelese · Not legal advice · BIA references current to 2025
        </div>
      </div>
    </div>
  );
}

function BackButton({ onClick }) {
  return (
    <div style={{ background: '#1A1A1A', padding: '10px 24px', fontFamily: "'DM Sans', -apple-system, sans-serif" }}>
      <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button
          onClick={onClick}
          style={{
            background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)',
            cursor: 'pointer', fontSize: 13, fontWeight: 500, padding: '6px 0',
            display: 'flex', alignItems: 'center', gap: 6
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'white'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
        >
          ← Back to NMA Bankruptcy
        </button>
        <a
          href="https://navigationalmind.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'rgba(255,255,255,0.5)', fontSize: 12, textDecoration: 'none',
            fontFamily: "'IBM Plex Mono', monospace", letterSpacing: '0.03em',
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.85)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}
        >
          navigationalmind.com ↗
        </a>
      </div>
    </div>
  );
}

function App() {
  const [section, setSection] = useState('landing');

  if (section === 'bankrupt') return (
    <>
      <BackButton onClick={() => setSection('landing')} />
      <BankruptSection />
    </>
  );
  if (section === 'trustee') return (
    <>
      <BackButton onClick={() => setSection('landing')} />
      <Form65Navigator />
    </>
  );
  if (section === 'creditor') return (
    <>
      <BackButton onClick={() => setSection('landing')} />
      <CreditorSection />
    </>
  );
  return <PlatformLanding onNavigate={setSection} />;
}

export default App;
